import { css } from 'styled-components';

export const disabledSectionMixin = css`
  opacity: 0.5;
  pointer-events: none;
`;
